<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » 予約状況詳細（編集）の説明
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card appearance="outlined" class="manual-card">
      <mat-card-header>
        <mat-card-title><span>予約状況詳細（編集）の説明</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/confirm-reservation-detail-dialog.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> 閉じるボタン
        </div>
        <div class="manual-explain">
          クリックすることでダイアログを閉じます。<br>
          その際、編集した内容は保存されません。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> 予約番号、展示ID、予約施設、属性、利用日、利用時間、登録日時、更新日時、キャンセル日時、キャンセル実行者、メール送信状況
        </div>
        <div class="manual-explain">
          予約情報を表示します。読み取り専用で変更はできません。<br>
          ※キャンセル日時とキャンセル実行者は、キャンセルされた時に表示されます。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> 予約状況
        </div>
        <div class="manual-explain">
          予約状況を選択することができます。<br>
          「受付中」の場合は「確定」か「落選」を選択することができます。<br>
          「受付中」以外の場合は選択できません。<br>
        </div>
        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> メモ
        </div>
        <div class="manual-explain">
          予約状況変更時の状況をメモとして登録することができます。<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> 予約情報項目
        </div>
        <div class="manual-explain">
          予約情報の各項目を表示します。読み取り専用で変更はできません。<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/F.png"> 更新ボタン
        </div>
        <div class="manual-explain">
          クリックすることで編集内容が更新されます。<br>
          予約状況で「確定」か「落選」を選択しないと押下できません。<br>
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">User Guide Top</a> » Explanation of Reservation Status Details (Edit)
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card appearance="outlined" class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Explanation of Reservation Status Details (Edit)</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_confirm-reservation-detail-dialog.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Close Button
        </div>
        <div class="manual-explain">
          Click to close the dialog.<br>
          Any unsaved changes will not be retained.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> Reservation Number, Exhibition ID, Reserved Facility, Attribute, Usage Date, Usage Time, Registration Date/Time, Update Date/Time, Cancellation Date/Time, Cancellation Executor, Email Send Status
        </div>
        <div class="manual-explain">
          Displays reservation information. This is read-only and cannot be changed.<br>
          *Cancellation Date/Time and Cancellation Executor are displayed when the reservation is cancelled.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Reservation Status
        </div>
        <div class="manual-explain">
          You can select the reservation status.<br>
          If the status is "Pending", you can select either "Confirmed" or "Rejected".<br>
          If the status is not "Pending", it cannot be changed.<br>
        </div>
        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> Memo
        </div>
        <div class="manual-explain">
          You can register the situation when changing the reservation status as a memo.<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> Reservation Information Items
        </div>
        <div class="manual-explain">
          Displays each item of the reservation information. This is read-only and cannot be changed.<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/F.png"> Update Button
        </div>
        <div class="manual-explain">
          Click to save the edited content.<br>
          This button cannot be pressed unless "Confirmed" or "Rejected" is selected in the reservation status.<br>
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
